import { Box, Link, Typography } from '@mui/material';
import { TournamentPlayerStatus } from '@okletsplay/core';
import { EntityStoreName } from 'app/enums/store';
import { useEntityRepositoryStatus } from 'app/hooks/store';
import { dispatchUnwrap } from 'app/utils/store';
import { BreakTimer } from 'modules/bracket/components/BreakTimer';
import { getTournamentActivity } from 'modules/tournament-activity/store/repository';
import { tournamentActivitySelector } from 'modules/tournament-activity/store/selectors';
import { CurrentTournamentStoreStatus } from 'modules/tournaments/store/current-tournament/enum';
import { updateInvitationStatus } from 'modules/tournaments/store/current-tournament/repository';
import React, { FC, useCallback } from 'react';
import { useSelector } from 'react-redux';
import { LoaderButton } from 'shared/components/LoaderButton/LoaderButton';
import { useStyles } from '../../styles/TournamentGameActivity.styles';

interface CheckinTournamentGameProps {
  onTournamentClick: () => void;
}

export const CheckinTournamentGame: FC<CheckinTournamentGameProps> = ({ onTournamentClick }) => {
  const { classes } = useStyles();

  const name = useSelector(tournamentActivitySelector.name);
  const timerDuration = useSelector(tournamentActivitySelector.timerDuration);
  const timerStartedAt = useSelector(tournamentActivitySelector.timerStartedAt);

  const tournamentActivity = useSelector(tournamentActivitySelector.activity);

  const tournamentId = tournamentActivity.tournament?.id;
  const teamId = tournamentActivity.team?.id;

  const isLoading = useEntityRepositoryStatus({
    [EntityStoreName.CurrentTournament]: CurrentTournamentStoreStatus.UpdatingInvitationStatus,
  });

  const breakTimer = (
    <BreakTimer prefix="- Starts in" startedAt={timerStartedAt} duration={timerDuration} />
  );

  const onClickHandler = useCallback(() => {
    if (!tournamentId || !teamId || isLoading) {
      return;
    }

    dispatchUnwrap(
      updateInvitationStatus({
        identifier: tournamentId,
        data: { teamId: teamId, status: TournamentPlayerStatus.Ready },
      }),
      {
        success: () => {
          dispatchUnwrap(getTournamentActivity());
        },
      }
    );
  }, [isLoading, teamId, tournamentId]);

  if (!breakTimer) {
    return null;
  }

  return (
    <Box className={classes.root}>
      <Box className={classes.container}>
        <Typography className={classes.lineClampText}>
          <Link onClick={onTournamentClick}>{name}</Link>
          &nbsp;
          {breakTimer}
        </Typography>

        <LoaderButton
          color="primary"
          variant="contained"
          loading={isLoading}
          onClick={onClickHandler}
          className={classes.button}
        >
          Check-in
        </LoaderButton>
      </Box>
    </Box>
  );
};
